import moment from "moment";
import { PAYRUN_STATUS_IDS, PayrunExtended } from "@xemplo/gp-types";

const TIME_DATE_FORMAT = "YYYY-MM-DD HH:mm:00.000";

/**
 * Builds the updatePayrunMilestones payload for a status-only change. All
 * existing milestone dates are passed through unchanged; only the status moves.
 */
export const createStatusPayload = (
  payrun: PayrunExtended,
  payrunStatusId: number | null,
) => ({
  payrunId: payrun.id,
  amendmentDueDateTime: moment(payrun.amendmentDueDateTime).format(
    TIME_DATE_FORMAT,
  ),
  preparationDueDateTime: moment(payrun.preparationDueDateTime).format(
    TIME_DATE_FORMAT,
  ),
  approvalDueDateTime: moment(payrun.approvalDueDateTime).format(
    TIME_DATE_FORMAT,
  ),
  payDateTime: moment(payrun.payDate).format(TIME_DATE_FORMAT),
  payCycleStartDateTime: moment(payrun.payCycleStartDate).format(
    TIME_DATE_FORMAT,
  ),
  payCycleEndDateTime: moment(payrun.payCycleEndDate).format(TIME_DATE_FORMAT),
  payrunStatusId: payrunStatusId ?? payrun.payrunStatusId,
});

export function showStatusOption(payrunStatusId: number) {
  return [
    PAYRUN_STATUS_IDS.AMENDEMENTS_SUBMITTED_SYSTEM_TRIGGERED,
    PAYRUN_STATUS_IDS.AMENDEMENTS_SUBMITTED_USER_TRIGGERED,
    PAYRUN_STATUS_IDS.PREPARED_USER_TRIGGERED,
  ].includes(payrunStatusId);
}

export type StatusOption = { id: number; value: string };

/**
 * The selectable statuses (and default) depend on whether the pay run has
 * already been prepared.
 */
export function getStatusOptions(payrunStatusId: number): {
  options: StatusOption[];
  defaultStatus: number;
} {
  const isPayrunPrepared =
    payrunStatusId === PAYRUN_STATUS_IDS.PREPARED_USER_TRIGGERED;
  const options: StatusOption[] = [
    { id: PAYRUN_STATUS_IDS.AMENDMENTS_ADDED, value: "Add Amendments" },
    isPayrunPrepared
      ? { id: PAYRUN_STATUS_IDS.PREPARED_USER_TRIGGERED, value: "Payrun Prepared" }
      : {
          id: PAYRUN_STATUS_IDS.AMENDEMENTS_SUBMITTED_USER_TRIGGERED,
          value: "Amendment Submitted",
        },
  ];
  const defaultStatus = isPayrunPrepared
    ? PAYRUN_STATUS_IDS.PREPARED_USER_TRIGGERED
    : PAYRUN_STATUS_IDS.AMENDEMENTS_SUBMITTED_USER_TRIGGERED;
  return { options, defaultStatus };
}
